
import React, { Component } from 'react';

class Complaints extends Component {
  constructor(props) 
  {
      super(props);
      //console.log("APP-Constructor Refahi", this.props.userRequestJson);
      props.getComplaintsDepartment();
      props.getUserComplaints(1);
    }
    state = { 
      errorMessage: "",
      amount: 0,
      isRegister: true
  }
  componentDidMount()
  {
      this.props.getUserComplaints(1);
  }
  render() { 
      const myLists = this.props.complaintsJson;  
      const listItems = myLists.map((myList) =>  
        <li key={myList.id} className={(myList.status !== 2) ? "Array-item" : "Array-item bg-light border border-success"}>
          <div className='title mb-2'>
            <span className='text-danger'>عنوان:</span> <span className='text-dark'>{myList.subject}</span>
          </div>
          <div className='describe mb-2'>
            <span className='text-danger font-weight-bold'>توضیحات:</span> <p className='text-dark multiple-line mb-0'>{myList.description}</p>
          </div>
          <div className='date'>
              {myList.created_at_fa}
          </div>
          <div className='describe bg-info rounded-pill text-left px-2 py-1 text-white'>
              <b>وضعیت:</b> {myList.status_text}
          </div>
          {(myList.status === 2 && myList.last_answer !== null) ? <div className='wp-text text-success font-weight-bold mt-2 text-justify'><div dangerouslySetInnerHTML={{__html: myList.last_answer.replace(/(<? *script)/gi, 'illegalscript')}} ></div></div> : <span></span> }
        </li>
        );
        return (
          <div className="w-100 body-padding">
              <p className='wp-header'>نظرات ثبت شده</p>  
              <ul className='Array p-0 mb-5'>
              {
                (listItems.length === 0) ? <li className='Array-item'><div className='title'>هنوز پیشنهادی توسط شما ثبت نشده است.</div></li> : listItems
              }
              </ul>
              <button onClick={this.props.toggleModal} className="btn dina-btn-orange wp-button-add-complaint"><span>+</span></button>
          </div>
      );
  }
}
export default Complaints;